import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../Auth/AuthProvider";
import jwt_decode from "jwt-decode";
import React from "react";

const Auth = ({ allowedRoles }) => {
  const { auth, setAuth, accessToken } = useContext(AuthContext);
  const location = useLocation();
  let permissionArray = [];
  if (accessToken) {
    const decodedToken = jwt_decode(accessToken);
    console.log('decodedToken@@@=>',decodedToken)
    const permissions = decodedToken.permissions;

    console.log(decodedToken);
    permissions &&
      permissions.map((vl) => {
        permissionArray.push(vl.name);
      });
  }

  console.log(allowedRoles, permissionArray);
  return allowedRoles.find((role) => permissionArray.includes(role)) ? (
    <Outlet />
  ) : (
    <Navigate to={"/no-access"} state={{ from: location }} replace />
  );
};

export default Auth;
